export function formatMessage(message, args) {
  return Object.keys(args).reduce((string, key) => {
    return string.replace(new RegExp(`{${key}}`, "g"), args[key]);
  }, message || "");
}
